import { makeStyles } from '@material-ui/core/styles';

export function useAttendanceLocalStyles() {
    const useStyles = makeStyles((theme) => ({
        addButton: {
            color: '#FFF',
            backgroundColor: '#004B97',
            fontSize: '0.95rem',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: '#003366',
            },
        },
        badge: {
            padding: 6,
            maxWidth: 50,
            letterSpacing: 1,
            fontSize: '0.8rem',
            fontWeight: 600,
            borderRadius: 20,
            textAlign: 'center',
            color: '#FFF',
        },
        active: {
            backgroundColor: '#2E7D32',
            '&:hover': {
                backgroundColor: '#2E7D32',
            },
        },
        inactive: {
            backgroundColor: '#C62828',
            '&:hover': {
                backgroundColor: '#C62828',
            },
        },
        tableContainer: {
            maxHeight: 600,
            minHeight: 400,
        },
        tableCell: {
            padding: '18px 16px',
        },
        tableTH: {
            color: '#FFF',
            backgroundColor: '#004B97',
            padding: '10px 16px',
        },
        paginationContainer: {
            padding: 16,
            display: 'flex',
            justifyContent: 'center',
            '& button': {
                borderRadius: 20,
            }
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}